export const TrackerLocation = {
  Deploy: 'deploy',
  GitHubPush: 'github push',
  Schema: 'schema',
  SyncConfig: 'sync config',
  SyncModels: 'sync models',
};
